module.exports = __webpack_public_path__ + "static/media/pointHand.71abcbaa.png";